export const abiosConfigName: string = 'letsbetmd';
